module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAUVBMVEUAAABxcXFnZ2dmZmZmZmZoaGhnZ2dnZ2doaGhmZmZnZ2dnZ2dnZ2doaGhoaGhnZ2dmZmZnZ2dnZ2dnZ2dnZ2doaGhnZ2dtbW1nZ2dmZmZmZmY/Pn55AAAAGnRSTlMACt3o9CZnjkrLtXFVQB7QwKujmXw3LxWFXVt4FP8AAADDSURBVDjLzZDNCsIwEAY3SZP+W2ut2nn/BxWWHLvrRcQ5BXYgfCN/QTfkj06I0AbxGQFScZ1ng7LMjrRBnCJws50H0EmB5mJLVxgkJLjbzgRkaSEGf75kYBKTO6QgA1xt59JAkQ542NINFv1ys50dmGWE5mlLPaxafLSdQwtu/vwEr1rc5KXztbg7/6jFTVboa3GbBF0t7oZsRy3uUFCWkxNQXxllPjkCUkmktWTxpVkFT1J+IfmoFHGJKu09Dv0uX+QNvH4bc6PiJ3MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/module/basic/assets/img/ic_edit.png
// module id = 295
// module chunks = 0